export const isLink = (link) => {
  return link && link.link_type !== 'Any';
};
